import { Injectable, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { FooterSelectors } from './footer.selectors';
import { AppState } from '@nx-customer-apps/shared/interfaces';
import { FooterActions } from './footer.actions';

@Injectable({ providedIn: 'root' })
export class FooterStore {
    private store$ = inject<Store<AppState>>(Store);

    public state$ = this.store$.pipe(select(FooterSelectors.getState()));

    public getApiInfo(): void {
        this.store$.dispatch(FooterActions.getApiInfo());
    }
}
